import React from "react";

let colorIndex = "#999";

const SvgClose = props => (
  <svg className="rzsvg-close" width={30} height={30}  {...props} >
    <path
      data-name="Path 8374"
      d="M15 30a15 15 0 1 1 15-15 15.017 15.017 0 0 1-15 15zm0-28a13 13 0 1 0 13 13A13.015 13.015 0 0 0 15 2zm1.213 13l4.539-4.539a.859.859 0 0 0 0-1.211.859.859 0 0 0-1.211 0L15 13.791l-4.54-4.539a.859.859 0 0 0-1.211 0 .859.859 0 0 0 0 1.211L13.791 15l-4.539 4.541a.856.856 0 0 0 1.211 1.211L15 16.213l4.539 4.539a.856.856 0 0 0 1.211-1.211z"
    />
  </svg>
);

export default SvgClose;
